import { FieldDef } from 'app/core/models';
import { RelatedToType } from '@shared/enums';

export namespace Field {
  export class SetDropdownOptions {
    static readonly type = '[FieldDefs] Set Dropdown Options';

    constructor(public options: { [option_name: string]: any[] }) {}
  }

  export class FetchTimeSeries {
    static readonly type = '[FieldDefs] Fetch TimeSeries Fields';

    constructor(public relatedToType: RelatedToType | string) {}
  }
}
